export const onAddNewDog = () => ({
  type: 'Add new dog',
  position: 'dropdown',
});

export const dropdownClicked = () => ({
  type: 'Click Change Dog Dropdown',
});
